<template>
  <div
    class="detail-scroll-top"
    v-if="hasScroll"
    @click="handleScrollTop"
    :style="{ left: position ? position.right + 14 + 'px' : null, bottom: bottom + 'px' }"
    title="回到顶部"
  >
    <i class="wiki-icon wiki-icon-top"></i>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      hasScroll: false,
      bottom: 16
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll() {
      const winScrollTop = window.document.documentElement.scrollTop || window.document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;

      if (winScrollTop > 0) {
        this.hasScroll = true;
      } else {
        this.hasScroll = false;
      }

      if (winScrollTop >= scrollHeight - windowHeight - 156) {
        // console.log("滚动到底部", scrollHeight - windowHeight - scrollTop);
        this.bottom = 156 - (scrollHeight - (winScrollTop + windowHeight));
      }
    }
  }
};
</script>

<style lang="less" scoped>
.detail-scroll-top {
  position: fixed;
  bottom: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .wiki-icon {
    width: 22px;
    height: 22px;
  }
}
</style>
